import { render, staticRenderFns } from "./CadastreBuildingFieldList.vue?vue&type=template&id=2fc67688&scoped=true&"
import script from "./CadastreBuildingFieldList.vue?vue&type=script&lang=js&"
export * from "./CadastreBuildingFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc67688",
  null
  
)

export default component.exports